export { default } from "./PageLazyLoading";
